<template>
    <div class="modal fade" :class="{show: showAlertModal }" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{data.header}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close', data.reload)">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-html="data.message"></div>
                <div class="modal-footer">
                    <!-- modal close button -->
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"  @click="$emit('close', data.reload)">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default{
    name: "AlertModal",
    props: {
        showAlertModal:Boolean,
        data:null,
    },

}
</script>
<style lang="scss" scoped>
    .show {
        display: block !important;
    }
    .hide {
        display: none !important;
    }
</style>
